import { ChangeDetectionStrategy, Component } from '@angular/core';
import { ICellRendererAngularComp } from 'ag-grid-angular';
import { ICellRendererParams } from 'ag-grid-community';
import { CmtFlagComponent } from '../../../ui/flag.component';
import { isoForVorwahl } from '../country-flag.util';
import { NumberBlock } from '../rufnummer/rufnummer.model';

@Component({
  selector: 'cmt-country-flag-cell',
  standalone: true,
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [CmtFlagComponent],
  template: `
    <span class="inline-flex items-center gap-2">
      @if (iso) { <cmt-flag [iso]="iso" width="1rem" height="0.72rem" /> }
      <span>{{ land }}</span>
    </span>
  `,
})
export class CountryFlagCellComponent implements ICellRendererAngularComp {
  protected iso: string | null = null;
  protected land = '';

  agInit(params: ICellRendererParams<NumberBlock>): void {
    this.hydrate(params);
  }

  refresh(params: ICellRendererParams<NumberBlock>): boolean {
    this.hydrate(params);
    return true;
  }

  private hydrate(params: ICellRendererParams<NumberBlock>): void {
    this.iso = isoForVorwahl(params.data?.vorwahl);
    this.land = params.data?.staLand ?? '';
  }
}
